import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'
const get = axios.get
const post = axios.post
const api = '/api/om/'
const gpi = '/api/gen/'

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const response = await request
    return response.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error.response?.data ?? {
        message: 'Unable to connect to the server.',
      }
    )
  }
}

export const OnlineProps = createAsyncThunk('online-props', (lang: string, thunkAPI) =>
  handleRequest(get(`${api}online-props/${lang}`), thunkAPI)
)

export const StoreMember = createAsyncThunk('store-member', (data: FormData, thunkAPI) =>
  handleRequest(post(`${api}store-member`, data), thunkAPI)
)

// Start Impersonation
export const StartImpersonate = createAsyncThunk(
  'start-impersonate',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/general/start-impersonate', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response)
      }
    }
  }
)

// Stop Impersonation
export const StopImpersonate = createAsyncThunk('stop-impersonate', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/general/stop-impersonate', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const Notifications = createAsyncThunk('notifications', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/general/notifications`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ReadNotification = createAsyncThunk('read-notify', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/general/read-notification/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const RelatedNotification = createAsyncThunk(
  'related-notification',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/general/related-notifications/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetOnlineProps = createAsyncThunk('online-props', async (lang: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/get-props/${lang}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SubmitOnlineApplication = createAsyncThunk(
  'submit-online-application',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/online-app-submit', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const Communes = createAsyncThunk('communes', (_, thunkAPI) =>
  handleRequest(get(`${gpi}communes`), thunkAPI)
)

export const Categories = createAsyncThunk('categories', (_, thunkAPI) =>
  handleRequest(get(`${gpi}categories`), thunkAPI)
)

type GeneralState = {
  general: any
  notification: any
}

const initialState: GeneralState = {
  general: [],
  notification: [],
}

export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(Notifications.fulfilled, (state, action: PayloadAction<any>) => {
      state.notification = action.payload
    })
  },
})

export const {reset} = generalSlice.actions
export default generalSlice.reducer
